import React from 'react'

const ReduxFormContext = React.createContext({
  change: () => null,
  formValues: {},
})

export default ReduxFormContext
